// extracted by mini-css-extract-plugin
module.exports = {"connected-text":"_2AokQ","connectedText":"_2AokQ"};